import {
  IconAnalytics,
  IconBell,
  IconBinocularsGray,
  IconChainLink,
  IconChartBar,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconLayers,
  IconLocation,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconWarning,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import mainVideo from '@src/assets/images/solution/constructionSafety/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/constructionSop/img/1.avif';
import image2 from '@src/assets/images/solution/constructionSop/img/2.avif';
import image3 from '@src/assets/images/solution/constructionSop/img/3.avif';
import image4 from '@src/assets/images/solution/constructionSop/img/4.avif';
import image5 from '@src/assets/images/solution/constructionSop/img/5.avif';
import image6 from '@src/assets/images/solution/constructionSop/img/6.avif';
import image7 from '@src/assets/images/solution/constructionSop/img/7.avif';
import image8 from '@src/assets/images/solution/constructionSop/img/8.avif';

export default {
  type: '消防解决方案',

  banner: {
    title: '通过数据验证消防训练成果，确保准确无误。',
    desc: '实时追踪消防员位置，客观评估训练执行情况，提升运营效率。',
  },

  // video: {
  //   title: '基于标准化流程自动检测事故并快速响应',
  //   desc: '实时检测作业人员动线及风险因素，基于SOP自动发送警报、记录及联动响应，实现安全措施系统化。数据自动保存，便于后期分析和审计。',
  //   play: mainVideo,
  // },

  summary: {
    function: {
      title: '通过数字化实现消防训练的精准评估与管理。',
      desc: '基于消防员的实时位置数据，客观分析训练过程及成果，高效管理。',
      card: [
        {
          image: '',
          title: '移动轨迹热力图可视化',
          desc: '将消防员的详细移动轨迹和动线以数据形式精准记录，用于评估训练目标是否达成。基于真实数据分析训练的准确性，明确改进点。',
        },
        {
          title: '详细移动轨迹数据分析',
          desc: '将消防员的详细移动轨迹和动线以数据形式精准记录，用于评估训练目标是否达成。基于真实数据分析训练的准确性，明确改进点。',
        },
        {
          title: '确保高精度位置数据接收',
          desc: '通过 TwinTracker 实现消防员位置数据的实时、无误差接收和记录，可对训练过程中的轨迹和位置进行精准分析。高精度数据接收提升了训练评估的可靠性，助力高效运营管理。',
        },
        {
          title: '实时综合运营监控',
          desc: '通过安装的 TwinTracker 实现对整个训练空间的实时一体化管理，快速掌握训练状态，提高运营效率与响应速度。',
        },
      ],
    },
  },

  numOfCard: {
    title: '基于数据的消防训练评估，最大化运营效率',
    desc: '通过客观训练数据，准确高效地改善现场运营。',
    card: [
      {
        tag: '97%',
        title: '训练移动轨迹自动记录准确率',
        desc: '在训练期间实时、准确地记录消防员的移动轨迹和位置，最大化训练评估的可信度。',
      },
      {
        tag: '95%',
        title: '实时位置追踪及覆盖率',
        desc: '全面覆盖训练场所内所有区域与人员，实现完美的实时监控。',
      },
      {
        tag: '99%',
        title: '现场与数字地图结构一致率',
        desc: '将现场结构精准再现于数字地图，确保与实际训练场所的高度一致性。',
      },
    ],
  },

  func: [
    {
      theme: '利用消防员位置追踪功能<br/>提高训练精准度。',
      title: 'TwinTracker 定制化现场安装实现高精度追踪',
      desc: '分析训练场内的地铁车厢、楼梯、通道等结构，将 TwinTracker 安装在最优位置。针对不同场所的特性进行细致布局和高效配置，确保消防员的位置追踪准确无误。',
      sub1: '高精度保障',
      icon1: IconRulerGray,
      sub2: '实时状态监控',
      icon2: IconClockGray,
      image: image1,
    },
    {
      title: '通过现场 TwinTracker 实现准确数据接收',
      desc: '安装在训练现场的 TwinTracker 可在地铁内部及复杂结构中稳定接收精准的位置信息，无干扰。高接收精度确保了消防员的实时位置数据可靠。',
      sub1: '快速数据联动',
      icon1: IconBinocularsGray,
      sub2: '实时位置追踪',
      icon2: IconTvocGray,
      image: image2,
    },
    {
      title: '基于现场结构构建的数字位置追踪环境',
      desc: '将训练现场的实际结构及地铁车厢等细节完整复现到数字地图，实现对消防员移动的直观监控。准确反映结构及障碍物，提高现场与数字界面的一致性，确保实时位置数据的准确性。',
      sub1: '实时位置追踪',
      icon1: IconBinocularsGray,
      sub2: '高精度保障',
      icon2: IconRulerGray,
      image: image3,
    },
    {
      title: '从安装图纸到 3D 可视化的一体化追踪方案',
      desc: 'TwinTracker 的安装基于精准的设计图纸，并可通过现场照片直观确认安装状态。结合直观的监控界面和逼真的 3D 可视化，实现从安装到运营的完整位置追踪方案。',
      sub1: '灵活区域设置',
      icon1: IconZoneGray,
      sub2: '多区域管理',
      icon2: IconTagGray,
      image: image4,
    },
  ],

  customer: {
    title: '查看选择 ORBRO 的客户真实评价',
    card: [
      {
        desc: '过去消防训练主要依赖经验和直觉进行评估。引入 ORBRO 的实时位置追踪系统后，我们能准确掌握消防员的训练过程和移动轨迹，且能通过客观数据直接确认训练成果，显著提高了评估的可信度和效率。我们相信这对未来的现场作业也将发挥巨大作用。',
        name: '首尔特别市消防灾难本部',
      },
    ],
  },

  subfunc: {
    title: '主要功能汇总',
    desc: '保障作业人员安全有助于提升效率并减少事故损失。ORBRO 为建筑现场作业人员提供了最佳功能组合，系统可在作业人员接近危险区域、发生事故或涉及重型机械潜在风险时，提供及时有效的响应措施。',

    data: [
      {
        icon: IconLocation,
        title: '实时位置追踪',
        desc: '在现场实时、准确追踪消防员位置。',
      },
      {
        icon: IconChartBar,
        title: '高精度安装与数据接收',
        desc: '通过定制化安装确保位置数据的准确性和稳定性。',
      },
      {
        icon: IconAnalytics,
        title: '移动轨迹热力图可视化',
        desc: '将训练中活动集中的区域以热力图形式直观呈现，便于评估。',
      },
      {
        icon: IconRoute,
        title: '训练移动轨迹自动记录',
        desc: '自动记录消防员的移动轨迹，支持基于数据的客观评估。',
      },
      {
        icon: IconLayers,
        title: '现场结构数字地图实现',
        desc: '将实际训练现场结构准确再现于数字地图，确保最大程度的一致性。',
      },
      {
        icon: IconLayers,
        title: '基于 3D 的训练管理',
        desc: '通过 3D 模型直观展示训练进度和状态。',
      },
      {
        icon: IconLocation,
        title: '可靠位置数据接收',
        desc: '即使在结构复杂或地铁车厢内，也能无干扰稳定提供位置信息。',
      },
      {
        icon: IconSearch,
        title: '联动管理安装图纸',
        desc: '从安装图纸到监控、3D 可视化，提供一体化位置追踪解决方案。',
      },
    ],
  },

  system: {
    title: '系统构成',
    img: rtlsSystem,
  },

  productTitle: '产品构成',
  product: [{ tag: 'workerPackage' }, { tag: 'assetPackage' }],

  contents: [{ data: 'constructionAsset' }, { data: 'constructionEquipment' }, { data: 'blogRTLS' }, { data: 'blogMedical' }],
};
